export default {"src":"/_next/static/media/medical.7751e83a.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};